import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-raiting',
  templateUrl: './raiting.component.html',
  styleUrls: ['./raiting.component.css']
})
export class RaitingComponent implements OnInit, OnChanges {
  @Input() score: number = 0;
  @Input() useAlternativeColor: boolean = false;

  starsFull: any;
  starsHalf: any;
  starsEmpty: any;

  constructor() { }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.score.currentValue) {
      this.calculateStars()
    }
  }

  ngOnInit(): void {
    //this.calculateStars();
  }

  calculateStars() {

    let originScore = this.score;
    let full;
    let half;
    let empty;

    if (originScore % 1 == 0) { //Si tiene un score entero
      full = originScore;
      half = 0;
      empty = 5 - originScore; //5 porque el maximo de estrellas es 5
    }
    else { //Si tiene un score decimal
      full = Math.floor(originScore)
      half = 1;
      empty = 4 - full; //4 porque el maximo es 5 y siempre va a haber una media estrella
    }

    //estos son array vacios solo para el ngFor.
    this.starsFull = new Array(full);
    this.starsHalf = new Array(half);
    this.starsEmpty = new Array(empty);

  }

}
